import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import './index.css';
import App from './App.tsx';
import { HybridAuthProvider } from './HybridAuthProvider.tsx';
import { ApiClientProvider } from './api/ApiClientContext.tsx';
import { QueryClientProvider } from '@tanstack/react-query';
import { appQueryClient } from './api/queryClient';
import { ConflictHandlerProvider } from './context/ConflictHandlerContext.tsx';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <MantineProvider>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <HybridAuthProvider>
        <ApiClientProvider>
          <QueryClientProvider client={appQueryClient}>
            <ConflictHandlerProvider>
              <App />
            </ConflictHandlerProvider>
          </QueryClientProvider>
        </ApiClientProvider>
      </HybridAuthProvider>
    </BrowserRouter>
  </MantineProvider>,
);
